import { useEffect, useState } from 'react';

import { useRealizedOptions } from './use-realized-options';
import { useImpliedOptions } from './use-implied-options';
import {
  ListTokenFrequency,
  VolatilityTypeEnum,
} from '../../../../../../providers/token-volatility-timeseries-provider';

interface UseSeriesManagerProps {
  listTokenFrequency: ListTokenFrequency;
  fetchListTokenFrequency: () => void;
}

export enum WindowTenorEnum {
  D1 = '1D',
  D3 = '3D',
  W1 = '1W',
  W2 = '2W',
  M1 = '1M',
  M2 = '2M',
  M3 = '3M',
  M6 = '6M',
  M9 = '9M',
  Y1 = '1Y',
}

export interface OptionConfig<T> {
  key: string;
  value: T;
  setValue: (value: T) => void;
  label: string;
  options: { label: string; value: T }[];
  otherOptions?: { label: string; value: T }[];
}

export const useSeriesManager = (props: UseSeriesManagerProps) => {
  const { listTokenFrequency, fetchListTokenFrequency } = props;

  const [volatility, setVolatility] = useState<VolatilityTypeEnum>(VolatilityTypeEnum.REALIZED);

  const volatilitiesOptions = [
    { value: VolatilityTypeEnum.REALIZED, label: 'Realized Vol' },
    { value: VolatilityTypeEnum.IMPLIED, label: 'Implied Vol' },
  ];

  const realizedOptions = useRealizedOptions({ listTokenFrequency });
  const impliedOptions = useImpliedOptions();

  const getOptionsArray = (): OptionConfig<any>[] => {
    if (volatility === VolatilityTypeEnum.IMPLIED) {
      return impliedOptions.options;
    }
    return realizedOptions.options as any;
  };

  useEffect(() => {
    if (listTokenFrequency && Object.keys(listTokenFrequency).length > 0) {
      return;
    }
    fetchListTokenFrequency();
  }, [fetchListTokenFrequency, listTokenFrequency]);

  return {
    volatility,
    setVolatility,
    volatilitiesOptions,
    options: getOptionsArray(),
  };
};
